export default class OptimizedLineupsViewNotFoundError extends Error {}
